import { Component, Input, Output, EventEmitter } from '@angular/core';

import { Resource } from '@shared/resource/models';
import { ResourceSettings } from '@shared/restaurant/models';
import { AppIcon, AppIconColor, AppIconSize } from '@tablesready/frontend-icons';

@Component({
  selector: 'tr-resources-list',
  styleUrls: ['./resources-list.component.scss'],
  templateUrl: './resources-list.component.html',
})
export class ResourcesListComponent {
  @Input() resourceSettings;
  @Input() serviceSettings;
  @Input() services;
  @Input() reservationsLabel;
  @Input() resources: Resource[] = [];
  @Input() showCategories = false;
  @Input() isReorder = false;
  @Input() resourcesCategories = new Set();

  @Output() resourceRemoved = new EventEmitter<Resource>();
  @Output() availabilityToggled = new EventEmitter<Resource>();
  @Output() addEditResourceCalled = new EventEmitter<Resource>();
  @Output() updatedBulk = new EventEmitter<Array<Partial<Resource>>>();
  @Output() resourceSettingsUpdated = new EventEmitter<Partial<ResourceSettings>>();

  icon = AppIcon;
  color = AppIconColor;
  size = AppIconSize;

  getServiceNames(serviceIds: string[]): string {
    if (!serviceIds || !this.services) {
      return '';
    }
    const services = this.services.filter(s => serviceIds.includes(s._id));
    const serviceNames = services.map(s => s.name);

    if (!serviceNames) {
      return '';
    }

    return serviceNames.length > 1 ? serviceNames.join(', ') : serviceNames[0];
  }

  addEditResource(resource: Resource): void {
    this.addEditResourceCalled.emit(resource);
  }

  deleteResource(resource: Resource): void {
    this.resourceRemoved.emit(resource);
  }

  toggleEnabled(resource: Resource): void {
    this.availabilityToggled.emit(resource);
  }

  move(pos: number, move: number): void {
    this.array_move(this.resources, pos, pos + move);
    const updates: Array<Partial<Resource>> = [];
    for (let i = 0; i < this.resources.length; i++) {
      this.resources[i].order = i;
      updates.push({
        _id: this.resources[i]._id,
        order: i,
      });
    }

    this.updatedBulk.emit(updates);
  }

  array_move(arr: Resource[], old_index: number, new_index: number): void {
    if (new_index >= arr.length) {
      let k = new_index - arr.length + 1;
      while (k--) {
        // eslint-disable-next-line no-undefined
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  }

  trackBy(index: number): number {
    return index;
  }
}
